


import { useState, useEffect, useContext } from "react";
import classes from "../Etablissements/Etablissements.module.css";
import {
  Button,
  Card,
  Dropdown,
  Space,
  Spin,
  Table,
  Tooltip,
} from "antd";
import { DownOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import axiosInstance from "../../utils/axios";
import { useNavigate } from "react-router-dom";


import DownloadDocsModal from "../Etablissements/DownloadDocsModal";
import { useLoader } from "../../context/LoaderContext";
import GlobalContext from "../../context/GlobalContext";
const ListeApprenants = () => {
  const { t } = useTranslation();

  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const { setIsLoading } = useLoader();
  const role = localStorage.getItem("role");

  const [downloadModalOpen, setDownloadModalOpen] = useState(false);
  const [currentDocs, setCurrentDocs] = useState(null);
  // const [pagination, setPagination] = useState({
  //   current: 1,
  //   pageSize: 10,
  //   total: 0,
  // });
  const {pagination, setPagination} = useContext(GlobalContext);

   const statutIds = [
      import.meta.env.VITE_APP_ID_DEMANDE_ELIGIBILITE_EN_COURS_DE_TRAITEMENT,
      import.meta.env.VITE_APP_ID_DEMANDE_ELIGIBILITE_DEMANDE_SOUMISE,
      import.meta.env.VITE_APP_ID_DEMANDE_ELIGIBILITE_DEMANDE_DOSSIER_MANQUANT,
      import.meta.env.VITE_APP_ID_DEMANDE_ELIGIBILITE_DEMANDE_COMPLEMENT_SOUMIS,
    ];




  const columns = [
    {
      title: t("Nom"),
      key: "Nom",
      render: (_, record) => (record?.name ? record?.name : t("Non renseigné")),
    },
    {
      title: t("Prénom"),
      key: "Prénom",
      render: (_, record) =>
        record?.surname ? record?.surname : t("Non renseigné"),
    },
    {
      title: t("Nationnalité"),
      key: "Nationnalité",
      render: (_, record) =>
        record?.nationality ? record?.nationality : t("Non renseigné"),
    },
        {
      title: t("Email"),
      key: "Email",
      render: (_, record) =>
        record?.adresse_mail ? record?.adresse_mail : t("Non renseigné"),
    },
    {
      title: t("Pièce d'identité"),
      key: "Pièce d'identité",
      render: (_, record) =>
       record?.cin || record?.extrait_naissance  || record?.passport,
    },
    {
      title: "Actions",
      key: "autre",
      render: (_, record) => (
        <Dropdown
          menu={{
            items: [
              {
                label: (
                  <Button
                    size="small"
                    block
                      onClick={() =>
                    {
                      setIsLoading(true)
                    navigate(`/sessionFormationHomologuee/detailsApprenant/${record?.id}`)
                    }}

                 
                  >
                    {t("Consulter")}
                  </Button>
                ),
                key: "1",
              },

              {

  key: "3",
},
            ],
          }}
          trigger={["click"]}
        >
          <a onClick={(e) => e.preventDefault()}>
            <Space>
              {t("Liste")}
              <DownOutlined />
            </Space>
          </a>
        </Dropdown>
      ),
    },
  ];

  const dataSourceWithKeys = data.map((item, index) => ({
    ...item,
    key: index,
  }));


  const fetchData = async (page = 1, pageSize = 10) => {
    setLoading(true);
    axiosInstance
      .get(
        `${import.meta.env.VITE_APP_GEOPROD_API

        }/list_apprenant?page=${page}&limit=${pageSize}`,
        
        {
          headers: {
            Idsession: JSON.parse(localStorage.getItem("-x-token-user"))
              ?.Acces_Token,
          },
        }
      )
      .then((res) => {
        
        setData(res?.data?.message?.Data);
        setPagination((prev) => ({
          ...prev,
          current: page,
          pageSize,
          total: res?.data?.message?.totalCount, 
        }));
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchData(pagination.current, pagination.pageSize);
  }, []);

  const handleTableChange = (pagination) => {
    fetchData(pagination.current, pagination.pageSize);
  };

  return (
    <Spin spinning={loading} tip="" style={{ width: "100%" }}>
      <div>
   
      
        <DownloadDocsModal
          open={downloadModalOpen} 
          setOpen={setDownloadModalOpen} 
          docs={currentDocs} 
        />
        <Card
          className={classes.listeCard}
      
          // title={
          //   <div>
          //     <div
          //       style={{
          //         display: "flex",
          //         justifyContent: "space-between",
          //         alignItems: "center",
          //       }}
          //     >
          //       <h3>
          //         {t(
          //           "Liste des apprenants"
          //         )}
          //       </h3>
          //     </div>
          //   </div>
          // }
        >
          <Table
            dataSource={dataSourceWithKeys}
            columns={columns}
            className="ant-border-space"
            style={{ overflowX: "auto" }}
            pagination={pagination}
            onChange={handleTableChange}
          />
        </Card>
      </div>
    </Spin>
  );
};

export default ListeApprenants;
